var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-Info" },
    [
      _c("div", { staticClass: "avatar" }, [
        _c(
          "div",
          { staticClass: "avatar-box" },
          [
            _c("img", {
              staticClass: "avatar-img-sty",
              attrs: { src: _vm.UserForm.imgPath, alt: "头像" }
            }),
            _c(
              "el-button",
              {
                staticStyle: { "margin-top": "20px" },
                attrs: { size: "small", type: "primary" },
                on: {
                  click: function($event) {
                    _vm.avatarVisi = true
                  }
                }
              },
              [_vm._v("修改头像")]
            )
          ],
          1
        )
      ]),
      _c("el-divider", { attrs: { "content-position": "left" } }, [
        _vm._v("基本资料")
      ]),
      _c(
        "div",
        { staticClass: "info-sty" },
        [
          _c(
            "el-form",
            {
              ref: "userFormRef",
              staticClass: "user-form-sty",
              attrs: {
                model: _vm.UserForm,
                "label-width": "180px",
                size: "small"
              }
            },
            [
              _vm.userType == 1
                ? [
                    _c("el-form-item", { attrs: { label: "企业名称：" } }, [
                      _c(
                        "div",
                        { staticClass: "item-box" },
                        [
                          _c("p", [_vm._v(_vm._s(_vm.UserForm.username))]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.changeNamePup }
                            },
                            [_vm._v("变更")]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "统一社会信用代码：" } },
                      [
                        _c("div", { staticClass: "item-box" }, [
                          _c("p", [_vm._v(_vm._s(_vm.UserForm.identityCardNo))])
                        ])
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: "邮箱账号：" } }, [
                      _c(
                        "div",
                        { staticClass: "item-box" },
                        [
                          [_c("p", [_vm._v(_vm._s(_vm.UserForm.email))])],
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  _vm.changeAccountVisi = true
                                }
                              }
                            },
                            [_vm._v("变更")]
                          )
                        ],
                        2
                      )
                    ])
                  ]
                : _vm._e(),
              _vm.userType == 0
                ? [
                    _c("el-form-item", { attrs: { label: "真实姓名：" } }, [
                      _c("div", { staticClass: "item-box" }, [
                        _c("p", [_vm._v(_vm._s(_vm.UserForm.name))])
                      ])
                    ]),
                    _c("el-form-item", { attrs: { label: "证件号：" } }, [
                      _c("div", { staticClass: "item-box" }, [
                        _c("p", [_vm._v(_vm._s(_vm.UserForm.identityCardNo))])
                      ])
                    ]),
                    _c("el-form-item", { attrs: { label: "手机号码：" } }, [
                      _c("div", { staticClass: "item-box" }, [
                        _c("p", [_vm._v(_vm._s(_vm.UserForm.mobilePhoneNo))])
                      ])
                    ])
                  ]
                : _vm._e(),
              _c("el-form-item", { attrs: { label: "账号密码：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c("p", [_vm._v("*********")]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            _vm.modifyPWDVisi = true
                          }
                        }
                      },
                      [_vm._v("修改")]
                    )
                  ],
                  1
                )
              ]),
              _c("el-form-item", { attrs: { label: "账户注销：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            _vm.writeOffVisi = true
                          }
                        }
                      },
                      [_vm._v("注销")]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      !_vm.isInDingTalk
        ? [
            _c("el-divider", { attrs: { "content-position": "left" } }, [
              _vm._v("第三方账户")
            ]),
            _c(
              "div",
              { staticClass: "info-sty" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "user-form-sty",
                    attrs: { "label-width": "180px", size: "small" }
                  },
                  [
                    _vm.userType == 0
                      ? _c("el-form-item", { attrs: { label: "邮箱：" } }, [
                          _c(
                            "div",
                            { staticClass: "item-box" },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.UserForm.email ? _vm.UserForm.email : ""
                                  )
                                )
                              ]),
                              _vm.UserForm.email
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: { click: _vm.emailEditFn }
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function($event) {
                                          _vm.PersonEmailVisi = true
                                        }
                                      }
                                    },
                                    [_vm._v("绑定")]
                                  )
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _c("el-form-item", { attrs: { label: "微信：" } }, [
                      _c(
                        "div",
                        { staticClass: "item-box" },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.UserForm.wechatbu &&
                                  _vm.UserForm.wechatbu.nickName
                                  ? _vm.UserForm.wechatbu.nickName
                                  : ""
                              )
                            )
                          ]),
                          _vm.UserForm.wechatbu && _vm.UserForm.wechatbu.bId
                            ? [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title: "是否确认解绑微信？",
                                      "confirm-button-text": "取消",
                                      "cancel-button-text": "确认解绑",
                                      icon: "el-icon-warning",
                                      "icon-color": "#ec1c1c"
                                    },
                                    on: { cancel: _vm.unBindWeChat }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "text"
                                        },
                                        slot: "reference"
                                      },
                                      [_vm._v("解绑")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.toWechatAuth }
                                },
                                [_vm._v("绑定")]
                              )
                        ],
                        2
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      [
        _c("el-divider", { attrs: { "content-position": "left" } }, [
          _vm._v("证书信息")
        ]),
        _c(
          "div",
          { staticClass: "info-sty" },
          [
            _c(
              "el-form",
              {
                staticClass: "user-form-sty",
                attrs: { "label-width": "180px", size: "small" }
              },
              [
                _c("el-form-item", { attrs: { label: "证书状态：" } }, [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.certStatus[_vm.certInfo.certStatus]))
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.certEditFn }
                        },
                        [_vm._v("更新证书")]
                      )
                    ],
                    1
                  )
                ]),
                _c("el-form-item", { attrs: { label: "发证机构：" } }, [
                  _c("div", { staticClass: "item-box" }, [
                    _c("p", [_vm._v(_vm._s(_vm.certInfo.caIssuer))])
                  ])
                ]),
                _c("el-form-item", { attrs: { label: "证书编号：" } }, [
                  _c("div", { staticClass: "item-box" }, [
                    _c("p", [_vm._v(_vm._s(_vm.certInfo.caNo))])
                  ])
                ]),
                _c("el-form-item", { attrs: { label: "有效期：" } }, [
                  _c("div", { staticClass: "item-box" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.certInfo.beginTime) +
                          " 至 " +
                          _vm._s(_vm.certInfo.endTime)
                      )
                    ])
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      _c(
        "el-dialog",
        {
          attrs: { title: "修改头像", visible: _vm.avatarVisi, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.avatarVisi = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "avatar-dia-body-sty" },
            [
              _c(
                "el-upload",
                {
                  attrs: {
                    action: "#",
                    limit: 1,
                    "show-file-list": false,
                    "before-upload": _vm.beforeIdeCareUpload
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("选择图片")]
                  )
                ],
                1
              ),
              _c("p", { staticClass: "p-tip" }, [
                _vm._v("支持jpg、jpeg、bmp、png格式，图片大小不超过5M")
              ]),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { gutter: 20 }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "avatar-img-sty", attrs: { span: 12 } },
                    [
                      _c("img", {
                        ref: "avatarCreateRef",
                        attrs: { src: _vm.avatarImgBase64, alt: "" }
                      })
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticClass: "avatar-img-sty croped-img-sty",
                      attrs: { span: 12 }
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cropedImg,
                            expression: "cropedImg"
                          }
                        ],
                        attrs: { src: _vm.cropedImg, alt: "效果" }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveProfile } },
                [_vm._v("上传头像")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.modifyPWDVisi,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.modifyPWDVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modifyPWDRef",
              staticClass: "user-form-sty",
              attrs: {
                "label-width": "100px",
                size: "small",
                model: _vm.PWDForm,
                rules: _vm.PwdRules
              }
            },
            [
              _c("el-form-item", { attrs: { label: "旧密码：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入密码", "show-password": "" },
                      model: {
                        value: _vm.PWDForm.pwd,
                        callback: function($$v) {
                          _vm.$set(_vm.PWDForm, "pwd", $$v)
                        },
                        expression: "PWDForm.pwd"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "新密码：", prop: "newpwd" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入密码",
                          "show-password": ""
                        },
                        model: {
                          value: _vm.PWDForm.newpwd,
                          callback: function($$v) {
                            _vm.$set(_vm.PWDForm, "newpwd", $$v)
                          },
                          expression: "PWDForm.newpwd"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.modifyPWDVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.ChangePassword }
                },
                [_vm._v("修改密码")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "账户注销", visible: _vm.writeOffVisi, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.writeOffVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "user-form-sty",
              attrs: { "label-width": "100px", size: "small" }
            },
            [
              _c("el-form-item", { attrs: { label: "密码：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c("el-input", {
                      attrs: { "show-password": "", placeholder: "请输入密码" },
                      model: {
                        value: _vm.checkPwd,
                        callback: function($$v) {
                          _vm.checkPwd = $$v
                        },
                        expression: "checkPwd"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.writeOffVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.writeOff } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "意愿认证",
            visible: _vm.writeOffQRVisi,
            width: "20%"
          },
          on: {
            "update:visible": function($event) {
              _vm.writeOffQRVisi = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("qrcode", {
                key: "evidence",
                attrs: { value: _vm.QRUrl, size: 140, leave: "H" }
              })
            ],
            1
          ),
          _c(
            "p",
            {
              staticStyle: {
                color: "#ec1c1c",
                "text-align": "center",
                "margin-top": "10px"
              }
            },
            [
              _vm._v(
                "完成人脸识别即代表您主动、自愿注销在君子签的账户(用户的账号)"
              )
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.writeOffQRVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.currStatus === "name" ? "变更企业名称" : "变更账号",
            visible: _vm.changeAccountVisi,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.changeAccountVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticClass: "user-form-sty",
              attrs: { "label-width": "100px", size: "small" }
            },
            [
              _c("el-form-item", { attrs: { label: "密码：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c("el-input", {
                      attrs: { "show-password": "", placeholder: "请输入密码" },
                      model: {
                        value: _vm.checkPwd,
                        callback: function($$v) {
                          _vm.checkPwd = $$v
                        },
                        expression: "checkPwd"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.changeAccountVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.verifyUser } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重要提示",
            visible: _vm.changeEmailVisi,
            "show-close": false,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.changeEmailVisi = $event
            }
          }
        },
        [
          _c("p", { staticStyle: { "margin-bottom": "1vh" } }, [
            _vm._v("当前账号信息：" + _vm._s(_vm.UserForm.email))
          ]),
          _c(
            "el-form",
            {
              ref: "changeEmailRef",
              staticClass: "user-form-sty",
              attrs: {
                "label-width": "100px",
                size: "small",
                model: _vm.accountForm,
                rules: _vm.accountRules
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新账号：", prop: "email" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入邮箱" },
                        model: {
                          value: _vm.accountForm.email,
                          callback: function($$v) {
                            _vm.$set(_vm.accountForm, "email", $$v)
                          },
                          expression: "accountForm.email"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新密码：", prop: "password" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-password": "",
                          placeholder: "请输入新密码"
                        },
                        model: {
                          value: _vm.accountForm.password,
                          callback: function($$v) {
                            _vm.$set(_vm.accountForm, "password", $$v)
                          },
                          expression: "accountForm.password"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "确认密码：", prop: "confirmPWD" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-password": "",
                          placeholder: "请确认密码"
                        },
                        model: {
                          value: _vm.accountForm.confirmPWD,
                          callback: function($$v) {
                            _vm.$set(_vm.accountForm, "confirmPWD", $$v)
                          },
                          expression: "accountForm.confirmPWD"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("p", [
            _c("span", { staticStyle: { color: "#ec1c1c" } }, [_vm._v("注：")]),
            _vm._v(
              "如因信息变更出现数据异常，以及后续所产生的一切法律责任均由您自行承担。"
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.changeEmailVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.changeEmailHand }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "意愿认证",
            visible: _vm.ChangeQRVisi,
            "show-close": false,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "20%"
          },
          on: {
            "update:visible": function($event) {
              _vm.ChangeQRVisi = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("qrcode", {
                key: "evidence",
                attrs: { value: _vm.changeQRUrl, size: 140, leave: "H" }
              })
            ],
            1
          ),
          _c(
            "h2",
            {
              staticStyle: {
                color: "#ec1c1c",
                "text-align": "center",
                "margin-top": "10px"
              }
            },
            [_vm._v("请企业法定代表人/授权人完成人脸识别")]
          ),
          _c(
            "p",
            {
              staticStyle: {
                color: "#ec1c1c",
                "text-align": "center",
                "margin-top": "10px"
              }
            },
            [
              _vm._v(
                "完成人脸识别即代表您主动、自愿将原账号（旧账号）变更为新账号（新账号）"
              )
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ChangeQRVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定邮箱",
            visible: _vm.PersonEmailVisi,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "20%"
          },
          on: {
            "update:visible": function($event) {
              _vm.PersonEmailVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "changeEmailRef",
              staticClass: "user-form-sty",
              attrs: {
                "label-width": "80px",
                "label-position": "left",
                size: "small",
                model: _vm.PersonAccount,
                rules: _vm.accountRules
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "邮箱：", prop: "email" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入邮箱" },
                        model: {
                          value: _vm.PersonAccount.email,
                          callback: function($$v) {
                            _vm.$set(_vm.PersonAccount, "email", $$v)
                          },
                          expression: "PersonAccount.email"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.bindPersonEmailHandle }
                },
                [_vm._v("绑 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.PersonchangeEmailVisi,
            "show-close": false,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.PersonchangeEmailVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "personChangeEmailRef",
              staticClass: "user-form-sty",
              attrs: {
                "label-width": "120px",
                size: "small",
                model: _vm.PersonAccount,
                rules: _vm.accountRules
              }
            },
            [
              _c("el-form-item", { attrs: { label: "原邮箱：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.UserForm.email, disabled: "" }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "图形验证码：", prop: "valicode" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { maxLength: 4, placeholder: "请输入验证码" },
                          model: {
                            value: _vm.PersonAccount.valicode,
                            callback: function($$v) {
                              _vm.$set(_vm.PersonAccount, "valicode", $$v)
                            },
                            expression: "PersonAccount.valicode"
                          }
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _c(
                              "span",
                              {
                                staticClass: "img-code",
                                on: { click: _vm.getImgCode }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "data:image/png;base64," +
                                      _vm.imgCodeData.imgPath
                                  }
                                })
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新邮箱：", prop: "email" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入新邮箱" },
                        model: {
                          value: _vm.PersonAccount.email,
                          callback: function($$v) {
                            _vm.$set(_vm.PersonAccount, "email", $$v)
                          },
                          expression: "PersonAccount.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                    _vm._v("注：请在新邮箱中点击链接激活邮箱换绑")
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.PersonchangeEmailVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.unbindEmailOfPerson }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(_vm.editCom, {
        tag: "component",
        attrs: {
          width: "30%",
          title: _vm.currStatus === "name" ? "变更企业名称" : "",
          visible: _vm.changeVisi,
          "show-close": false,
          "close-on-press-escape": false,
          "close-on-click-modal": false,
          UserForm: _vm.UserForm,
          checkPwd: _vm.checkPwd
        },
        on: {
          "update:visible": function($event) {
            _vm.changeVisi = $event
          },
          "update:checkPwd": function($event) {
            _vm.checkPwd = $event
          },
          "update:check-pwd": function($event) {
            _vm.checkPwd = $event
          },
          checkUserStatus: _vm.checkUserStatus,
          certRenewal: _vm.certRenewal
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7edfe683", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edfe683","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/components/accountInfo/personAccount.vue
// module id = Z5uJ
// module chunks = 0 61 86 145